import {
  Box,
  Input,
  Button,
  VStack,
  Select as SelectChakra,
  Textarea,
  useToast,
  Flex,
} from "@chakra-ui/react";
import Select from "react-select";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
const BASE_URL = "https://develop-project-360.onrender.com/createLeadDeal"; // adjust if needed

export const createLead = (payload) => axios.post(`${BASE_URL}`, payload);

export default function CreateLead({ onClose, addNewLead }) {
  const companyIdGlobal = useSelector((store) => store.authentication.users.id);
  const [users, setUsers] = useState([]);

  const handleEmployeeChange = (selectedOptions) => {
    if (selectedOptions.some((opt) => opt.value === "All")) {
      const allIds = users.map((u) => u._id);
      setFormData((prev) => ({
        ...prev,
        assigned_to: allIds,
      }));
    } else {
      const ids = selectedOptions.map((option) => option.value);
      setFormData((prev) => ({
        ...prev,
        assigned_to: ids,
      }));
    }
  };

  const toast = useToast();
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(
          `https://develop-project-360.onrender.com/getUserById?companyId=${companyIdGlobal}`
        );
        setUsers(res.data);
      } catch (error) {
        console.error("Failed to fetch users", error);
      }
    };

    fetchUsers();
  }, [companyIdGlobal]);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    client_name: "",
    client_email: "",
    client_phone: "",
    company_name: "",
    industry: "",
    source: "",
    type: "Lead",
    assigned_to: [],
    companyId: companyIdGlobal,
    created_by: companyIdGlobal,
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    try {
      const { data } = await createLead(formData);
      addNewLead(data); // Pass the new lead to parent
      toast({
        title: "Lead created successfully",
        description: `${formData.title} created successfully`,
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top-right",
        variant: "subtle",
      });
      onClose(); // Close the modal
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to create lead",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top-right",
      });
    }
  };

  return (
    <Box>
      <VStack spacing="4">
        <Input name="title" placeholder="Title" onChange={handleChange} />
        <Textarea
          name="description"
          placeholder="Description"
          onChange={handleChange}
        />
        {/* <Flex gap={4} direction={{ base: "column", md: "row" }}> */}
        <Input
          name="client_name"
          placeholder="Client Name"
          onChange={handleChange}
        />
        {/* </Flex> */}

        <Flex gap={4} direction={{ base: "column", md: "row" }}>
          <Input
            name="client_email"
            placeholder="Email"
            onChange={handleChange}
          />
          <Input
            name="client_phone"
            placeholder="Phone"
            onChange={handleChange}
          />
        </Flex>
        <Flex gap={4} direction={{ base: "column", md: "row" }}>
          <Input
            name="company_name"
            placeholder="Company Name"
            onChange={handleChange}
          />
          <Input
            name="industry"
            placeholder="Industry"
            onChange={handleChange}
          />
        </Flex>
        <Box w={"100%"}>
          <Select
            placeholder="Assign To"
            isMulti
            isSearchable
            name="assigned_to"
            id="assigned_to"
            onChange={handleEmployeeChange}
            options={[
              { value: "All", label: "All" },
              ...users.map((employee) => ({
                value: employee._id,
                label: employee.sudo_name || employee.first_name,
              })),
            ]}
            value={formData.assigned_to.map((id) => {
              const employee = users.find((u) => u._id === id);
              return {
                value: employee?._id,
                label: employee?.sudo_name || employee?.first_name,
              };
            })}
          />
        </Box>
        <SelectChakra name="source" onChange={handleChange}>
          <option value="">Select Source</option>
          <option value="Website">Website</option>
          <option value="Referral">Referral</option>
          <option value="Cold Call">Cold Call</option>
          <option value="Social Media">Social Media</option>
          <option value="Event">Event</option>
          <option value="Others">Others</option>
        </SelectChakra>
        <Button colorScheme="teal" w="full" onClick={handleSubmit}>
          Create Lead
        </Button>
      </VStack>
    </Box>
  );
}
